(function () {
  'use strict';

  function initStickyShopNowSupport() {
    if (document.documentElement.dataset.stickyShopNowSupportBound === 'true') return;

    const stickyShopNow = document.querySelector('[data-sticky-shop-now]');
    if (!stickyShopNow) return;
    document.documentElement.dataset.stickyShopNowSupportBound = 'true';

    const stickyLabel = stickyShopNow.querySelector('.sticky-shop-now__label');
    const productRoot = document.querySelector('[id^="MainProduct-"]') || document;

    function updateStickyShopNowLabel() {
      if (!stickyLabel) return false;

      const normalizeValue = (value, options = {}) => {
        const normalized = String(value || '').trim();
        const lowerValue = normalized.toLowerCase();
        if (!normalized || lowerValue === '-- please select --' || lowerValue === 'please select' || lowerValue === '请选择') return '';
        if (lowerValue.indexOf('select ') === 0) return '';
        if (normalized === '0' && !options.allowZero) return '';
        return normalized;
      };

      const getOptionName = (block) => {
        const field = block.querySelector('[key], select[name], input[name]');
        const fieldName = field?.getAttribute('key') || field?.getAttribute('name') || '';
        const labelText = block.querySelector('.po-label')?.textContent || '';
        return `${fieldName} ${labelText}`.toLowerCase();
      };

      const getBlockValue = (block, options = {}) => {
        const checkedInputs = block.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (checkedInputs.length) {
          return normalizeValue(Array.from(checkedInputs).map(input => input.value).filter(Boolean).join(', '), options);
        }

        const customSelected = block.querySelector('.po-value.po-dropdown-selected-option');
        if (customSelected) return normalizeValue(customSelected.innerText, options);

        const select = block.querySelector('select');
        if (select && select.value) {
          return normalizeValue(select.options[select.selectedIndex]?.text || select.value, options);
        }

        const textField = Array.from(
          block.querySelectorAll('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="search"]), textarea')
        ).find(field => !field.closest('.po-select-dropdown-thumbnail, .po-option--dropdown-menu-container'));
        if (textField) return normalizeValue(textField.value, options);

        return '';
      };

      const isWidthFraction = (name) => name.includes('width') && name.includes('fraction');
      const isHeightFraction = (name) => (name.includes('height') || name.includes('length')) && name.includes('fraction');
      const isWidthWhole = (name) => name.includes('width') && name.includes('inch') && !name.includes('fraction');
      const isHeightWhole = (name) => (name.includes('height') || name.includes('length')) && name.includes('inch') && !name.includes('fraction');

      const optionBlocks = productRoot.querySelectorAll('.po-stack, .po-option--container');
      const parts = [];
      let width = '';
      let widthFraction = '';
      let height = '';
      let heightFraction = '';

      optionBlocks.forEach(block => {
        if (block.offsetParent === null) return;

        const optionName = getOptionName(block);
        if (isWidthFraction(optionName)) {
          widthFraction = getBlockValue(block, { allowZero: true });
          return;
        }
        if (isHeightFraction(optionName)) {
          heightFraction = getBlockValue(block, { allowZero: true });
          return;
        }
        if (isWidthWhole(optionName)) {
          width = getBlockValue(block);
          return;
        }
        if (isHeightWhole(optionName)) {
          height = getBlockValue(block);
          return;
        }

        const value = getBlockValue(block);
        if (value && !parts.includes(value)) parts.push(value);
      });

      const measurement = [
        width ? `${width} '' ${widthFraction || '0'}W` : '',
        height ? `* ${height} '' ${heightFraction || '0'}H` : '',
      ].filter(Boolean).join(' ');

      if (measurement) {
        const insertIndex = parts.length ? 1 : 0;
        parts.splice(insertIndex, 0, measurement);
      }

      const nextLabel = parts.length ? parts.join(' / ') : '';
      if (stickyLabel.innerText !== nextLabel) stickyLabel.innerText = nextLabel;
      return Boolean(nextLabel);
    }

    window.updateStickyShopNowLabel = updateStickyShopNowLabel;
    document.addEventListener('sticky-shop-now:activate', updateStickyShopNowLabel);

    let stickyLabelTimer = null;
    function scheduleStickyShopNowLabel(delay = 50) {
      if (stickyShopNow.dataset.active !== 'true') return;
      clearTimeout(stickyLabelTimer);
      stickyLabelTimer = setTimeout(() => {
        if (stickyShopNow.dataset.active === 'true') updateStickyShopNowLabel();
      }, delay);
    }

    const optionRoot = document.querySelector('.bss-po-product-page') ||
      document.querySelector('[id^="MainProduct-"]');
    if (optionRoot) {
      optionRoot.addEventListener('change', () => scheduleStickyShopNowLabel(), true);
      optionRoot.addEventListener('input', event => {
        if (
          !event.target.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="search"]), textarea') ||
          event.target.closest('.po-select-dropdown-thumbnail, .po-option--dropdown-menu-container')
        ) return;
        scheduleStickyShopNowLabel(100);
      }, true);
      optionRoot.addEventListener('click', event => {
        if (!event.target.closest('.po-option--swatch, .po-option__value, .po-option__swatch-wrapper, .bss_scroll')) return;
        scheduleStickyShopNowLabel();
      }, true);
    }

    // The visibility observer can activate before this deferred support asset runs.
    // In that case, synchronize once from the active state instead of attaching
    // persistent option listeners.
    if (stickyShopNow.dataset.active === 'true') updateStickyShopNowLabel();

    function setImportantStyle(element, property, value) {
      if (
        element.style.getPropertyValue(property) === value &&
        element.style.getPropertyPriority(property) === 'important'
      ) {
        return;
      }

      element.style.setProperty(property, value, 'important');
    }

    function getMdwFloatButton() {
      return document.querySelector([
        '.mdw-app-container .mdw-float-btn',
        '.mdw-AppWidget-container .mdw-float-btn',
        '.custom-app-container .custom-float-btn',
        '.custom-float-btn',
      ].join(','));
    }

    function syncMdwFloatButtonPosition() {
      const faqButton = getMdwFloatButton();
      if (!faqButton) return false;

      const bottomOffset = window.matchMedia('(max-width: 767.98px)').matches ? '135px' : '160px';
      setImportantStyle(faqButton, 'bottom', bottomOffset);
      setImportantStyle(faqButton, 'right', '5px');
      return true;
    }

    let mdwFloatButtonFrame = null;
    function scheduleMdwFloatButtonPosition() {
      if (mdwFloatButtonFrame) return;
      mdwFloatButtonFrame = requestAnimationFrame(() => {
        mdwFloatButtonFrame = null;
        syncMdwFloatButtonPosition();
      });
    }

    let lastViewportWidth = window.innerWidth;
    window.addEventListener('load', scheduleMdwFloatButtonPosition, { once: true });
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastViewportWidth) return;
      lastViewportWidth = window.innerWidth;
      scheduleMdwFloatButtonPosition();
    }, { passive: true });

    let mdwFloatButtonStyleObserver = null;
    const observeMdwFloatButton = () => {
      const faqButton = getMdwFloatButton();
      if (!faqButton || mdwFloatButtonStyleObserver) return false;
      mdwFloatButtonStyleObserver = new MutationObserver(scheduleMdwFloatButtonPosition);
      mdwFloatButtonStyleObserver.observe(faqButton, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
      scheduleMdwFloatButtonPosition();
      return true;
    };

    const mdwFloatButtonMountObserver = new MutationObserver(() => {
      if (observeMdwFloatButton()) mdwFloatButtonMountObserver.disconnect();
    });
    if (!observeMdwFloatButton()) {
      mdwFloatButtonMountObserver.observe(document.body || document.documentElement, {
        subtree: true,
        childList: true,
      });
      window.setTimeout(() => mdwFloatButtonMountObserver.disconnect(), 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyShopNowSupport, { once: true });
  } else {
    initStickyShopNowSupport();
  }
}());
